
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vaga/[id]",
      function () {
        return require("private-next-pages/vaga/[id].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vaga/[id]"])
      });
    }
  